export const INPUT_PROMPT = "Entrez le nom d'une région...";
export const INPUT_NO_INPUT = "Veuillez entrer un nom de région.";
export const INPUT_NO_MATCH = "Région non reconnue. Vérifiez l\'orthographe.";
export const INPUT_ERROR = "Erreur lors de la recherche de la région.";
export const INPUT_PLACEHOLDER = "Commencez à taper pour chercher...";
export const SHARE_COPY_SUCCESS = "Résultats copiés dans le presse-papiers!";
export const SHARE_COPY_IMPOSSIBLE = "Impossible de copier automatiquement. Sélectionnez et copiez manuellement.";

export const LONGEST_DISTANCE = 1005; // Distance between Abitibi-Témiscamingue and Gaspésie
